import axios from 'axios'
import { AppSettings } from '../../configs'
import { authHeader } from '../../helpers/auth-header'
import utilityHelper from '../../helpers/helperUtil'
import {Storage} from '../../configs'
import {data_uom,data_payment_method ,
    data_payment_supplement,
    data_withcode ,
    data_currencycode ,
    data_payment_term ,
    data_vat,
} from '../../configs/datas'
import {
    START_LOADING,
    STOP_LOADING,
    GET_EMPLOYEE_INFO,
    GET_SEARCH_DIRECTORY_INFO,
    // GET_PLANT_INFO,
    // GET_BUSINESS_PLACE,
    // GET_GL_ACCOUNT,
    // GET_COST_CENTER,
    // GET_ASSET,
    GET_VAT,
    GET_CURRENCY_CODE,
    GET_PAYMENT_METHOD,
    GET_PAYMENT_SUPPLEMENT,
    GET_PAYMENT_TERM,
    //GET_WITH_CODE,
    GET_REGION,
    GET_COUNTRY,
    GET_BANKBRANCH,
    GET_BANKNAME,
    GET_MASTER_VAT,
    GET_MR_FORM,
    GET_MR_VENDORTYPE,
    GET_SLOC_WITH_PLANTS,
    GET_VENDOR,
    GET_MR_REF_LIST,
    GET_MR_PO_STATUS,
    GET_UNIT_UOM,
    GET_ASSET_CLASS,
    GET_ORG_UNIT,
    MASTER_CLEAR,
    GET_RESON_EVAL,
    GET_WHT_VALIDATE,
    GET_MASTER_REJECTOPTION,
  
} from "./actionTypes";

export  function getEmployeeInfoAction(employeeCode) {
    return  function (dispatch) {
            dispatch({
                type: START_LOADING
            })

            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetEmployeeInfoAsync`,
                params: {
                    employeeCode: employeeCode
                }
            })

            promise.then(response => {
                let results = response.data
                let employeePIS = null

                if (results && results.length > 0) {
                    employeePIS = results[0]
                }

                dispatch({
                    type: GET_EMPLOYEE_INFO,
                    payload: employeePIS,
                });

                dispatch({
                    type: STOP_LOADING
                })
            }
            )

            promise.catch(error=>{
                dispatch({type: STOP_LOADING})
            })

            return promise
    }
  }

export function getSearchDirectoryInfoAction(employeeCode, employeeName, positionName, positionABBR ,secondmentFlag, departmentCode, departmentName, departmentABBR, offset,limit) {
 
    return function (dispatch) {
            let params = {
                employeeID: employeeCode,
                employeeName: employeeName,
                positionName:positionName,
                positionABBR:positionABBR,
                secondmentFlag:secondmentFlag,
                departmentCode:departmentCode,
                departmentName:departmentName,
                departmentABBR:departmentABBR,
                offset:offset,
                limit:limit,
            }

            // if (employeeCode === '') {
            //     params = {
            //         employeeName: employeeName,
            //     }
            // }

            // if (employeeName === '') {
            //     params = {
            //         employeeID: employeeCode,
            //     }
            // }
            
            dispatch({
                type: START_LOADING
            })

            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetSearchDirectoryInfoAsync`,
                params: params
            })

            promise.then(response => {
                dispatch({
                    type: STOP_LOADING
                })
            })

            promise.catch(error=>{
                dispatch({
                    type : STOP_LOADING
                })
            })

            //.then(response => {
            //     console.log('getSearchDirectoryInfoAction:')
            //     console.log(response.data)

            // let results=response.data
            // let employeeSearchPIS=null

            // if(results && results.length>0){
            //     employeeSearchPIS=results
            // }

            // dispatch({
            //     type:GET_SEARCH_DIRECTORY_INFO,
            //     payload: employeeSearchPIS,
            //   });
            // }
            // )

            return promise
    }
}

export async function getSearchDirectoryInfoAwaitAction(employeeCode, employeeName, positionName, positionABBR) {
    
    let promise = await axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/master/GetSearchDirectoryInfoAsync`,
        params: {
            employeeID: employeeCode,
            employeeName: employeeName,
            positionName:positionName,
            positionABBR:positionABBR
        }
    })
    
    return promise
}

  export  function clearSearchDirectoryInfoAction() {
    return  function (dispatch) {
      try {
        dispatch({
            type:GET_SEARCH_DIRECTORY_INFO,
            payload: null,
        });
       
      } catch (error) {
           
      }
    }
  }
  
export  function getPlantInfoAction(purOrg) {
    return  function (dispatch) {
        let promise= axios({
            headers: authHeader(),
            method: "post",
            url: `${AppSettings.apiUrl}/api/master/GetPlantAsync`,
            params: {
                purOrg:purOrg
            }
        })
        
        // promise.then(response => {
        //     // console.log('getPlantInfoAction:')
        //     // console.log(response.data)

        //     dispatch({
        //         type: GET_PLANT_INFO,
        //         payload: response.data,
        //     });
        // }
        // );

        return promise
    }
}

export function getBusinessPlaceAction(businessPlace,description) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetBusinessPlaceAsync`,
                params: {
                    businessPlace:businessPlace,
                    description:description
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_BUSINESS_PLACE,
            //         payload: response.data,
            //     });
            // }
            // )

            return promise
        } catch (error) {
        }
    }
}

export function getGLAccountAction(searchGlAccount,offset,limit) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetGLAccountAsync`,
                params: {
                    searchGlAccount:searchGlAccount,
                    offset:offset,
                    limit:limit
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_GL_ACCOUNT,
            //         payload: response.data,
            //         selectList : utilityHelper.toSelectList2(response.data,"shorT_TEXT","gL_ACCOUNT_NO")
            //     });
            // }
            // )

            return promise
        } catch (error) {
        }
    }
}


export  function getCostCenterAction(searchCostCenter,offset,limit) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetCostCenterAsync`,
                params: {
                    searchCostCenter:searchCostCenter,
                    offset:offset,
                    limit:limit
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_COST_CENTER,
            //         payload: response.data,
            //         selectList : utilityHelper.toSelectList2(response.data,"description","cosT_CENTER")
            //     });
            // }
            // )

            return promise
        } catch (error) {
        }
    }
}

export  function getCostCenterActiveAction(searchCostCenter,offset,limit) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/CheckActiveCostCenter`,
                params: {
                    searchCostCenter:searchCostCenter,
                    offset:offset,
                    limit:limit
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_COST_CENTER,
            //         payload: response.data,
            //         selectList : utilityHelper.toSelectList2(response.data,"description","cosT_CENTER")
            //     });
            // }
            // )

            return promise
        } catch (error) {
        }
    }
}

export function getAssetAction(searchAsset,isDummy,offset,limit) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetAssetAsync`,
                params: {
                    searchAsset:searchAsset,
                    isDummy:isDummy,
                    offset:offset,
                    limit:limit
                }
            })
            
            // promise.then(response => {
            //     // console.log('getAssetAction:')
            //     // console.log(response.data)

            //     dispatch({
            //         type: GET_ASSET,
            //         payload: response.data,
            //     });
            // }
            // );

            return promise
        } catch (error) {
        }
    }
}

export  function getAssetModalAction(searchAsset,isDummy,offset,limit) {
    return  function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetAssetAsync`,
                params: {
                    searchAsset:searchAsset,
                    isDummy:isDummy,
                    offset:offset,
                    limit:limit
                }
            })

            return promise
        } catch (error) {
        }
    }
}

export function getVatAction(language,taxCode,description) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetVatAsync`,
                params: {
                    language:language,
                    taxCode:taxCode,
                    description:description
                }
            })
            
            promise.then(response => {
                // console.log('getVatAction:')
                // console.log(response.data)

                dispatch({
                    type: GET_VAT,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export function getVatCurrencyCodeAction(language,currencyCode,currencyDesc) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetCurrencyCodeAsync`,
                params: {
                    language:language,
                    currencyCode:currencyCode,
                    currencyDesc:currencyDesc
                }
            })
            
            promise.then(response => {
                // console.log('getVatCurrencyCodeAction:')
                // console.log(response.data)

                dispatch({
                    type: GET_CURRENCY_CODE,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export function getPaymentMethodAction(language,payMethod) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetPaymentMethodAsync`,
                params: {
                    language:language,
                    payMethod:payMethod
                }
            })
            
            promise.then(response => {
                // console.log('getPaymentMethodAction:')
                // console.log(response.data)

                dispatch({
                    type: GET_PAYMENT_METHOD,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getPaymentSupplementAction(paymentSupplement,text) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetPaymentSupplementAsync`,
                params: {
                    paymentSupplement:paymentSupplement,
                    text:text
                }
            })
            
            promise.then(response => {
                // console.log('getPaymentSupplementAction:')
                // console.log(response.data)

                dispatch({
                    type: GET_PAYMENT_SUPPLEMENT,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getPaymentTermAction(acctType,dayLimit,paymentTerm) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetPaymentTermAsync`,
                params: {
                    acctType:"K",
                    dayLimit:dayLimit,
                    paymentTerm:paymentTerm
                }
            })
            
            promise.then(response => {
                // console.log('getPaymentTermAction:')
                // console.log(response.data)
                
                dispatch({
                    type: GET_PAYMENT_TERM,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getWithCodeAction(countryKey,language,withholdingCode) {
    return  function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetWithCodeAsync`,
                params: {
                    countryKey:countryKey,
                    language:language,
                    withholdingCode:withholdingCode
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_WITH_CODE,
            //         payload: response.data,
            //     });
            // }
            // );

            return promise
        } catch (error) {
        }
    }
}

export  function getWithCodeByVendorAction(countryKey,language,withholdingCode,vendorCode , company_code , payment_type) {
    return  function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetWithCodeByVendorAsync`,
                params: {
                    countryKey:countryKey,
                    language:language,
                    withholdingCode:withholdingCode,
                    vendorCode:vendorCode ,
                    company_code:company_code ,
                    payment_type:payment_type
                }
            })
            
            // promise.then(response => {
            //     dispatch({
            //         type: GET_WITH_CODE,
            //         payload: response.data,
            //     });
            // }
            // );

            return promise
        } catch (error) {
        }
    }
}

export  function getSloc_WithPlantListAction(purOrg,plants) {
    return  function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetSloc_WithPlantListAsync`,
                params: {
                    purOrg:purOrg,
                    plants: plants
                }
            })
            
            promise.then(response => {
                // console.log('getSloc_WithPlantListAction:')
                // console.log(response.data)

                dispatch({
                    type: GET_SLOC_WITH_PLANTS,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getControlConfigAction(role,documentType,isActive,isDeleted) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/RRS/GetControlConfig`,
                params: {
                    Role_id:role,
                    Document_type:documentType,
                    isActive:isActive,
                    isDeleted:isDeleted
                }
            })
            
            promise.then(response => {
                //   dispatch({
                //     type: GET_CONTROL_CONFIG,
                //     payload: response.data,
                // });
                Storage.setControlConfigs(response.data)
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getRegionAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'Region'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_REGION,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getCountryAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'Country'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_COUNTRY,
                    payload: response.data,
                });
            }
            );
            
            return promise
        } catch (error) {
        }
    }
}

export  function getBankBranchAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'BankBranch'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_BANKBRANCH,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getBankNameAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'BankName'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_BANKNAME,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getMasterVatAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'Vat'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_MASTER_VAT,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getMasterRejectOptionAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'RejectOption'
                }
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_MASTER_REJECTOPTION,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getMRFormAction() {
    
    return  function (dispatch) {
        try {

            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMRForm`,
            })
            
            promise.then(response => {
                  dispatch({
                    type: GET_MR_FORM,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {

        }
    }
}

export  function getMRVendorTypeAction() { 
    return  function (dispatch) {
        try {
 

            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMRVendorType`,
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_MR_VENDORTYPE,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function getMrRefListAction(poNo,tranNo) { 
    return  function (dispatch) {
        try {
 

            let promise=  axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/RRS/GetMrRefList`,
                params: {
                    poNo:poNo,
                    transaction_no:tranNo,
                }
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_MR_REF_LIST,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function getPOStatusAction(tranNo) { 
    return  function (dispatch) {
        try {
 

            let promise=  axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/RRS/GetPOStatus`,
                params: {
                    transaction_no:tranNo,
                }
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_MR_PO_STATUS,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function getExchangeRateAction(formAmount,fromCur,toCur,validDate) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetExchangeRateAsync`,
                params: {
                    formAmount:formAmount,
                    fromCur:fromCur,
                    toCur:toCur,
                    validDate:validDate,
                    exrateType:"M"
                }
            })

            return promise
        } catch (error) {
        }
    }
}

export  function getVendorInfoAction() { 
    return  function (dispatch) {
        try {

            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetVendorAsync`
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_VENDOR,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function getVendorListAction(vendorName, vendorCode, offset, limit) { 
    return  function (dispatch) {
        dispatch({
            type: START_LOADING
          })
        try {
            
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetVendorAsync`,
                params:{
                    vendorName:vendorName,
                    vendorCode:vendorCode,
                    offset:offset,
                    limit:limit
                }
            })
            
            promise.then(response => {
                // dispatch({
                //     type: GET_VENDOR,
                //     payload: response.data,
                // });
                dispatch({
                    type: STOP_LOADING
                  })
            });

            return promise
        } catch (error) { 
            dispatch({
                type: STOP_LOADING
              })
        }
    }
}

export  function getVendorInformationAction(vendorNo) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Wso2/GetVendorInformation`,
                params: {
                    vendorNo:vendorNo
                }
            })

            return promise
        } catch (error) {
        }
    }
}

export  function getIOAction(auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetIOAsync`,
                params: {
                    auart:auart,
                    processingGrp:processingGrp,
                    description:description,
                    orderNumber:orderNumber,
                    searchCostCenter:searchCostCenter,
                    searchIo:searchIo,
                    offset:offset,
                    limit:limit
                }
            })

            return promise
        } catch (error) {

        }
    }
}

export  function getIOActiveAction(auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/CheckActiveIO`,
                params: {
                    auart:auart,
                    processingGrp:processingGrp,
                    description:description,
                    orderNumber:orderNumber,
                    searchCostCenter:searchCostCenter,
                    searchIo:searchIo,
                    offset:offset,
                    limit:limit
                }
            })

            return promise
        } catch (error) {

        }
    }
}

export  function getIOPmOrderAction(order_no, order_disc, offset, limit) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetIoPmOrderAsync`,
                params: {
                    search_pm_order:"",
                    order_no:order_no,
                    order_disc:order_disc,
                    order_status:"",
                    main_work_center:"",
                    plant_for_work_center:"",
                    planning_plant:"",
                    planner_group:"",
                    create_from:"",
                    create_to:"",
                    offset:offset,
                    limit:limit
                }
            })

            return promise
        } catch (error) {

        }
    }
}
            
export  function getUOMAction() { 
    return  function (dispatch) {
        try {
 

            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetUOMAsync`,
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_UNIT_UOM,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export function getBudgetAction(ioNo) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Wso2/GetBudget`,
                params: {
                    ioNo:ioNo,
                }
            })
            
            return promise
        } catch (error) {
        }
    }
}

export async function getBusinessInformationAction(requestType, fiscalYear, ioNo, planVersion) {

    let promise = await axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/Wso2/GetBusinessInformation`,
        params: {
            requestType:requestType,
            fiscalYear:fiscalYear,
            ioNo:ioNo,
            planVersion:planVersion
        }
    })
    
    return promise
    
}

export function GETEWHTConditionValidationCheckInquiryAction(comcode , vendor , wtax_code1, wtax_code2,post_date,pmt_method) {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Wso2/GETEWHTConditionValidationCheckInquiry`,
                params: {
                    comcode: comcode ,
                    vendor: vendor,
                    wtax_code1: wtax_code1,
                    wtax_code2: wtax_code2 ,
                    post_date: post_date,
                    pmt_method: pmt_method
                }
            })
            
            return promise
        } catch (error) {
        }
    }
}

// export async function GETEWHTConditionValidationCheckInquiryAction(comcode , vendor , wtax_code1, wtax_code2) {

//     let promise = await axios({
//         headers: authHeader(),
//         method: "post",
//         url: `${AppSettings.apiUrl}/api/Wso2/GETEWHTConditionValidationCheckInquiry`,
//         params: {
//             comcode: comcode ,
//             vendor: vendor,
//             wtax_code1: wtax_code1,
//             wtax_code2: wtax_code2
//         }
//     })
//     return promise;   
// }

// export async function GETEWHTConditionValidationCheckInquiryAction(comcode , vendor , wtax_code1, wtax_code2) {
//     return  function (dispatch) {
//         try {

//           dispatch({
//             type: START_LOADING
//           })

//           let promise=  axios({
//               headers: { ...authHeader(), 'Pragma': 'no-cache' },
//               method: "get",
//               url: `${AppSettings.apiUrl}/api/Wso2/GETEWHTConditionValidationCheckInquiry`,
//               params: {
//                 comcode: comcode ,
//                 vendor: vendor,
//                 wtax_code1: wtax_code1,
//                 wtax_code2: wtax_code2
//               }
//           })

//           promise.then(response => { 
//             dispatch({
//               type: GET_WHT_VALIDATE,
//               payload: response.data,
//           });
//         }
//           ).catch (error=> {
//             dispatch({
//               type: STOP_LOADING
//             })
//           })

//             return promise
//         } catch (error) {
//         }
//     }
// }




export  function getAssetClassAction() {
    return  function (dispatch) {
        try {
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'AssetClass'
                }
            })
            
            promise.then(response => {
                    // console.log("assetClasses:")
                    // console.log(response.data)

                  dispatch({
                    type: GET_ASSET_CLASS,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {
        }
    }
}

export  function getAssetClassNameAction(id) {
    console.log("getAssetClassNameAction:" ,id)

    return new Promise(function(resolve, reject) {
            let result=null
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'AssetClass',
                    value : id
                }
            })
            
            promise.then(response => {
                 let assetClases=response.data

                 if(assetClases && assetClases.length>0){
                    result=assetClases[0].key1
                 }

                //  console.log("getAssetClassNameAction.response:")
                //  console.log(assetClases)

                 resolve(result)
            }
            )
            .catch(error=>{
                reject(error)
            })
    })
}

export  function getAssetClassFirstAction(id) {
    console.log("getAssetClassFirstAction:" ,id)

    return new Promise(function(resolve, reject) {
            let result=null
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
                params: {
                    key:'AssetClass',
                    value : id
                }
            })
            
            promise.then(response => {
                 let assetClases=response.data

                 if(assetClases && assetClases.length>0){
                    result=assetClases[0]
                 }

                //  console.log("getAssetClassFirstAction.result:")
                //  console.log(result)
                //  console.log(response.data)

                 resolve(result)
            }
            )
            .catch(error=>{
                reject(error)
            })
    })
}

export function getPMLocationAction(plant) {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/master/GetPmLocationAsync`,
                params: {
                    plant:plant
                }
            })
            
            return promise
}

export  function getAllOrgUnitsAction() { 
    return  function (dispatch) {
        try {
 
            let promise=  axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Master/GetAllOrgUnitsAsync`,
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_ORG_UNIT,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function ClearMasterAction() { 
    return  function (dispatch) {
        try {
             
            dispatch({type: MASTER_CLEAR});

            return true
        } catch (error) { 

        }
    }
}

export function getMatBatchFlagAction(material_no, plant, offset, limit) {
    return function (dispatch) {
      try {
        dispatch({
          type: START_LOADING
        })
  
        let promise = axios({
          headers: authHeader(),
          method: "post",
          url: `${AppSettings.apiUrl}/api/Master/GetMatBatchFlagAsync`,
          params: {
            material_no: material_no,
            plant: plant,
            offset: offset,
            limit: limit
          }
        })
  
        promise.then(response => {
          dispatch({
            type: STOP_LOADING
          })
        }).catch(error => {
          dispatch({
            type: STOP_LOADING
          })
        })
  
        return promise
  
      } catch (error) {
        dispatch({
          type: STOP_LOADING
        })
      }
    }
  }

export  function getValidateMatBatchFlagAction(material_no, plant, offset, limit) {

    let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/Master/GetMatBatchFlagAsync`,
        params: {
          material_no: material_no,
          plant: plant,
          offset: offset,
          limit: limit
        }
      })
    
    return promise
    
}

export  function getMRResonNotEvalAction() { 
    return  function (dispatch) {
        try {

            let promise=  axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/Master/GetReasonNotEval`,
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_RESON_EVAL,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}